import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { T } from './theme';
import { extrak, udvozloExtrak, udvozloLatogatas, udvozloBezaras } from '../../lib/extrak';
import { openLanding, openTerminal } from '../../lib/openLanding';
import { track } from '../../lib/track';

/* Navigáció 1. kör: „A fiókodhoz tartozik még” blokk és az üdvözlő kártya a /tanfolyamok oldalon
   (a kártyák listája: lib/extrak.js). Mérés: egyetem_extrak_kattintas {cel}, egyetem_udvozlo_megjelent,
   egyetem_udvozlo_bezarva, egyetem_dashboard_kattintas {hely} — e-mail és azonosító nélkül. */

function useGo(session) {
  const navigate = useNavigate();
  return (hova) => {
    if (hova.tipus === 'terminal') openTerminal(hova.path);
    else if (hova.tipus === 'landing') openLanding(hova.path);
    else if (hova.tipus === 'route') navigate(hova.path);
    else if (hova.tipus === 'kulso') window.open(hova.path, '_blank', 'noopener,noreferrer');
    else window.location.href = hova.path;
  };
}

const btn = {
  background: 'none', border: `1px solid ${T.accentLine}`, color: T.accent, borderRadius: 10,
  padding: '8px 12px', fontWeight: 700, fontSize: 13, cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left',
};

function Kartya({ k, onGo }) {
  return (
    <div data-testid={`extra-${k.cel}`} data-nyitott={k.nyitott ? '1' : '0'} style={{
      background: T.surface, border: `1px solid ${T.line}`, borderRadius: 14, padding: '14px 16px',
      display: 'flex', flexDirection: 'column', gap: 8, minWidth: 0, opacity: k.nyitott ? 1 : 0.72,
    }}>
      <div style={{ color: T.text, fontWeight: 700, fontSize: 15 }}>{k.nyitott ? '' : <span aria-label="Zárt">🔒 </span>}{k.cim}</div>
      <div style={{ color: k.nyitott ? T.muted : T.faint, fontSize: 13, lineHeight: 1.5, flex: 1 }}>{k.sor}</div>
      {k.gombok.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {k.gombok.map(g => <button key={g.cel} type="button" style={btn} onClick={() => onGo(g)}>{g.felirat}</button>)}
        </div>
      )}
    </div>
  );
}

/** „A fiókodhoz tartozik még” — a szint szerinti kártyák. */
export function AccountExtras({ access, session, isMobile, discordOsszekotve = false }) {
  const go = useGo(session);
  const lista = extrak(access, { discordOsszekotve });
  if (!lista.length) return null;
  const onGo = (g) => { track(session, 'egyetem_extrak_kattintas', { cel: g.cel }); go(g.hova); };
  return (
    <section aria-labelledby="w3k-extrak" style={{ marginTop: isMobile ? 28 : 40 }}>
      <h2 id="w3k-extrak" style={{ color: T.text, fontSize: 18, fontWeight: 700, margin: '0 0 14px' }}>A fiókodhoz tartozik még</h2>
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(230px, 1fr))', gap: 12 }}>
        {lista.map(k => <Kartya key={k.cel} k={k} onGo={onGo} />)}
      </div>
    </section>
  );
}

/** Üdvözlő kártya: legfeljebb az első három látogatáson, bezárás után soha (lib/extrak.js). */
export function WelcomeCard({ access, session, isMobile, discordOsszekotve = false }) {
  const go = useGo(session);
  const uid = session?.user?.id;
  const [lathato, setLathato] = useState(false);
  const jelzett = useRef(false);
  useEffect(() => {
    if (!uid || !access) return;
    const v = udvozloLatogatas(uid);
    setLathato(v);
    if (v && !jelzett.current) { jelzett.current = true; track(session, 'egyetem_udvozlo_megjelent', {}); }
    // a látogatás oldalbetöltésenként egyszer számít
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid, Boolean(access)]);
  if (!lathato || !access) return null;
  const lista = udvozloExtrak(access, { discordOsszekotve });
  const bezar = () => { udvozloBezaras(uid); setLathato(false); track(session, 'egyetem_udvozlo_bezarva', {}); };
  return (
    <section aria-label="Üdv az egyetemen" data-testid="udvozlo" style={{
      position: 'relative', marginBottom: isMobile ? 24 : 32, padding: isMobile ? '18px 16px' : '22px 26px',
      background: T.accentSoft, border: `1px solid ${T.accentLine}`, borderRadius: 16,
    }}>
      <button type="button" aria-label="Bezárás" onClick={bezar} style={{
        position: 'absolute', top: 8, right: 8, background: 'none', border: 'none', color: T.muted, fontSize: 20, cursor: 'pointer', padding: 6, lineHeight: 1,
      }}>×</button>
      <div style={{ color: T.text, fontWeight: 700, fontSize: 16, margin: '0 28px 10px 0' }}>Üdv az egyetemen! A tanfolyamok mellett ezek is a tiéd:</div>
      <ul style={{ listStyle: 'none', margin: '0 0 14px', padding: 0, display: 'grid', gap: 6 }}>
        {lista.map(k => (
          <li key={k.cel} style={{ color: T.body, fontSize: 14, lineHeight: 1.45 }}>
            <b style={{ color: T.text }}>{k.cim}</b> · {k.sor}
          </li>
        ))}
      </ul>
      <button type="button" onClick={() => { track(session, 'egyetem_dashboard_kattintas', { hely: 'udvozlo' }); go({ tipus: 'landing', path: '/dashboard' }); }}
        style={{ border: 'none', borderRadius: 10, padding: '10px 16px', fontWeight: 700, fontSize: 14, cursor: 'pointer', fontFamily: 'inherit', background: T.accent, color: '#0a0f1e' }}>
        Dashboard megnyitása →
      </button>
    </section>
  );
}
